import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import shopController from "../../node_modules/shops-query/src/modules/shop";

const getCustomDomain = () => {
  const hostname = window.location.hostname;    
  // localhost or 127.0.0.1
  if (hostname === "localhost" || hostname === "127.0.0.1") {    
    return process.env.REACT_APP_CUSTOM_DOMAIN;
  }

  // production
  return hostname;
};

export const getShopId = async () => {
  try {
    const customDomain = getCustomDomain();        
    const data = await shopController.fetchShops({
      customDomain
    });    
    return data?.[0]?.id ?? null;
  } catch (error) {
    console.error("Error getting shop ID:", error);
    return null;
  }
};
getShopId();

export const shopid = Number(await getShopId());

export const getUserData = () => {
  try {
    const cookieValue = Cookies.get("ualum");
    if (!cookieValue) return null;

    const userData = JSON.parse(cookieValue);

    return {
      u_id: userData.u_id || null,
      user_id: userData.user_id || null,
      username: userData.user_name || null,
      email: userData.email || null,
      mobile: userData.mobile || null,
      first_name: userData.first_name || null,
      last_name: userData.last_name || null,
      roles: userData.roles || null,
    };
  } catch (error) {
    console.error("Error reading user data:", error);
    return null;
  }
};

export const getUserId = () => {
  try {
    const cookieValue = Cookies.get("ualum");
    if (!cookieValue) return null;

    const userData = JSON.parse(cookieValue);
    return userData.u_id || userData.user_id || userData.id || null; // 👈 main numeric ID
  } catch (error) {
    console.error("Error getting user ID:", error);
    return null;
  }
};

export const imagePrefix = "https://storage.strackit.com/";
